import $ from 'jquery';
import plugin from '@core/plugins/lib';
import {mustache} from '@core/plugins/lib/strings';

const ELEMENT_SELECTOR = '[data-category-and-product-selector]';
const ELEMENT_ATTR = 'data-category-and-product-selector';
const PRODUCT_ELEMENT_SELECTOR = '[data-category-and-product-selector-product]';
const CATEGORY_ELEMENT_SELECTOR = '[data-category-and-product-selector-category]';
const CATEGORY_ELEMENT_CONTAINER_SELECTOR = '[data-category-and-product-selector-category-wrapper]';
const PRODUCT_WRAPPER_ELEMENT_SELECTOR = '[data-category-and-product-selector-product-wrapper]';
const PRODUCT_WRAPPER_FIELD_ATTR='data-category-and-product-selector-product-wrapper';
const PRODUCT_ATTR = 'data-selected-product';
const CATEGORY_ATTR = 'data-selected-category';
const PRODUCT_FIELD_NAME_ATTR = 'data-product-field-name';
const PRODUCT_FIELD_ATTRS_ATTR ='data-product-field-attrs';
const ITEM_TEMPLATE_SELECTOR = '#productCategoryTemplate';
const CLASSNAME = "input-hidden";
const ATTRIBUTES_SELECTOR = '[data-attributes]';
const ATTRIBUTES_ATTR = 'data-attributes';
const HIDDEN_SELECTOR = '[data-category-and-product-selector-hidden]';
const HIDDEN_PRODUCT_SELECTOR = '[data-category-and-product-selector-product-hidden]';
const PLUGIN_NAME = 'CategoryAndProductSelector';

class CategoryAndProductSelector {
	constructor(element, options) {
        this.element = element;
		this.options = options;
		this.$element = $(element);       
        this.$productElementWrapper = this.$element.find(PRODUCT_WRAPPER_ELEMENT_SELECTOR);
        this.productWrapperId = this.$productElementWrapper.attr(PRODUCT_WRAPPER_FIELD_ATTR);
        this.$productWrapperElement = $(this.productWrapperId);

        this.selectedProduct = this.$element.attr(PRODUCT_ATTR);
        this.selectedCategory = this.$element.attr(CATEGORY_ATTR);
        this.productFieldName = this.$element.attr(PRODUCT_FIELD_NAME_ATTR);
        this.productFieldAttrs = this.$element.attr(PRODUCT_FIELD_ATTRS_ATTR);
        this.$hiddenElement = this.$element.find(HIDDEN_SELECTOR);
        this.$hiddenProductElement = this.$element.find(HIDDEN_PRODUCT_SELECTOR);
        this.$categoryElementContainer = this.$element.find(CATEGORY_ELEMENT_CONTAINER_SELECTOR);
        this.itemTemplate = $(ITEM_TEMPLATE_SELECTOR).text();
        this.$attributesEl = this.$element.find(ATTRIBUTES_SELECTOR);
        this.attributes = this.$attributesEl.attr(ATTRIBUTES_ATTR);
        this.id = this.$element.attr(ELEMENT_ATTR);
        this.$errorElement = this.$categoryElementContainer.find('span');
        this.productSet = false;

        this.$productWrapperElement.hide();
        if (this.selectedProduct.length > 0 && this.selectedCategory.length == 0) {
            this.loadSelectedCategory();
        }
        else {
            this.loadCategories();
        }

        /* Jira SCF-269 - Extra form check to fix bug where a user could click next while the page was still loading and the
         'input[data-category-and-product-selector-product-hidden]' element was empty. This was happening intermittently 
         if moving quickly back and forwards between the first 2 steps and selecting different categories.
        */
        $('.getaquoteform button[name="__next"]').click(function(e) {

            if($('input[data-category-and-product-selector-product-hidden]').length){
                
                if(!$('input[data-category-and-product-selector-product-hidden]').val() ) {
                    var form = $('.getaquoteform > form');
                    form.validate();

                    if(form.valid()){
                        e.preventDefault();
                    }
                } 
            }
        });
    }

    SetCategoriesDropdown(data) {
        var mod = this;
        var $errorEl = this.$errorElement.detach();
        $.each(data, function(i, v) {
            var selected = v.Checked || v.Value.replace(' ','') == mod.selectedCategory ? "checked=checked" : "";
            
            var html = mustache(mod.itemTemplate, {
                Name:mod.id + 'category',
                Value:v.Value,
                Label: v.Value,
                ImageUrl: v.ImageUrl,
                Id:v.Id,
                Attributes:mod.attributes,
                Selected: selected
            });
            mod.$categoryElementContainer.append(html);
        });
             
        
        this.$categoryElementContainer.append($errorEl);
        this.$categoryElement = this.$element.find(CATEGORY_ELEMENT_SELECTOR);        
        this.watch();
    }


    SetProductsDropdown(data) {
        var mod = this;
        var $errorEl = this.$errorElement.detach();
        var hideProducts = true;
        mod.$productElementWrapper.empty();  
        $.each(data, function(i, v) {
            var selected = v.Checked || v.Value.replace(' ','') == mod.selectedProduct ? "checked=checked" : "";
            
            hideProducts = false;
            var html = mustache(mod.itemTemplate, {
                Name:mod.productFieldName,
                Value:v.Id,
                Label: v.Value,
                ImageUrl: v.ImageUrl,
                Id:v.Id,                
                Attributes:mod.productFieldAttrs,
                Selected: selected
            });
            mod.$productElementWrapper.append(html);
        });

        
        if (hideProducts) {
            // this.$productWrapperElement.addClass(CLASSNAME);
            this.$productWrapperElement.hide();
        }
        else {
            // this.$productWrapperElement.removeClass(CLASSNAME);
            this.$productWrapperElement.show();
        }
        this.$productElementWrapper.append($errorEl);
        this.$productElement = this.$element.find(PRODUCT_ELEMENT_SELECTOR);
        
        this.$productElement.change(function() {
            mod.$hiddenProductElement.val($(this).val()).trigger('change');   
            $(document).trigger('product-selected');                    
        });

        if (!this.productSet) {
            mod.$hiddenProductElement.val('');
            mod.$hiddenProductElement.val(mod.selectedProduct).trigger('change');
            this.productSet=true;
        }
    }

    loadCategories() {
        var mod = this;        
        mod.$hiddenElement.val('');  
        var url = "/Umbraco/Api/GetProducts/GetCategories?selectedCategory=" + this.selectedCategory;
        $.ajax({
			url,
			method: 'get',
			success: result => {
                mod.SetCategoriesDropdown(result);
			},
			error: e => {
			}
		}).done(() => {
            
		});
    }

    loadSelectedCategory() {
        var mod = this;        
        var url = "/Umbraco/Api/GetProducts/GetCategoryByProduct?productId=" + this.selectedProduct;
        $.ajax({
			url,
			method: 'get',
			success: result => {
                mod.selectedCategory = result;
                mod.loadCategories();
			},
			error: e => {
			}
		}).done(() => {
            
		});
    }

    loadProducts() {
        var mod = this;
        var category = '';     
        mod.$hiddenProductElement.val('');
        $.each(this.$categoryElement, function(i, v) {
            var $eleme = $(v);
            if ($eleme.is(':checked')) {
                category = $eleme.val();
            }
        });

        
        var url = "/Umbraco/Api/GetProducts/GetProductsByCategory?category=" + category + '&selectedProduct=' + this.selectedProduct;
        $.ajax({
			url,
			method: 'get',
			success: result => {
				mod.SetProductsDropdown(result);
			},
			error: e => {
                mod.$productElementWrapper.addClass(CLASSNAME);
			}
		}).done(() => {
            

		});

        
    }

    watch() {
        var mod = this;
        this.$categoryElement.on('change', function() {
            mod.loadProducts();
            var newvalue = $(this).val();
            mod.$hiddenElement.val(newvalue).trigger('change').focus().blur();
        });
        if (mod.selectedCategory.length > 0) {
            mod.$hiddenElement.val(mod.selectedCategory);           
            mod.loadProducts();
            
        }
        if (mod.selectedProduct.length > 0) {
            mod.$hiddenProductElement.val('');
            mod.$hiddenProductElement.val(mod.selectedProduct).trigger('change');
            $(document).trigger('product-selected'); 
        }
    }
}

CategoryAndProductSelector.DEFAULTS = {};

plugin(PLUGIN_NAME, CategoryAndProductSelector);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();

    //prevent multiple form submissions (SCF-317 - Duplicate quote entries)
    $('.getaquoteform > form').on('submit', function (e) {

        var $form = $('.getaquoteform > form');

        if ($form.data('submitted') === true) {
            e.preventDefault();
        } else {
            $form.validate();
            if($form.valid()) {
                $form.data('submitted', true);
            }
        }
    });

});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/category-and-product-selector.js